import * as React from 'react'

import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { CreateApiKeyResponse } from '~/gen/proto/bff/v1/admin_pb'
import { ApiKeyForm } from '~/pages/ApiKeys/components/ApiKeyForm'
import { ApiKeyFormFields } from '~/pages/ApiKeys/components/ApiKeyForm/apiKeyFormSchema'
import CredentialModal from '~/pages/ApiKeys/components/CredentialModal'
import { useCreateApiKey } from '~/pages/ApiKeys/hooks/useCreateApiKey'

type Props = {
  defaultValues?: ApiKeyFormFields
}

export const CreateApiKeyForm: React.FC<Props> = ({ defaultValues }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [credential, setCredential] =
    React.useState<CreateApiKeyResponse | null>(null)

  const { mutate, isPending } = useCreateApiKey((response) => {
    setCredential(response)
  })

  const onCloseCredential = (): void => {
    const apiKeyId = credential?.apiKey?.id
    setCredential(null)
    if (apiKeyId === undefined) {
      void navigate({ to: '/api_keys' })
      return
    }
    void navigate({ to: '/api_keys/$apiKeyId', params: { apiKeyId } })
  }

  return (
    <>
      <ApiKeyForm
        defaultValues={defaultValues}
        isSubmitting={isPending}
        summary={{
          title: t('pages.api_keys.create.summary.title'),
          submitLabel: t('pages.api_keys.create.summary.submit'),
          caution: t('pages.api_keys.create.summary.caution'),
        }}
        onSubmit={(values) => {
          mutate(values)
        }}
      />
      <CredentialModal
        open={credential !== null}
        onClose={onCloseCredential}
        keyPrefix={credential?.apiKey?.keyPrefix ?? ''}
        rawKey={credential?.rawKey ?? ''}
      />
    </>
  )
}
